import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MktBannerComponent } from './mkt-banner.component';

@NgModule({
  declarations: [MktBannerComponent],
  imports: [CommonModule],
  exports: [MktBannerComponent],
  bootstrap: [MktBannerComponent]
})
export class MktBannerModule {}
